import { useState, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/AppTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { assetsClearService } from "./assetsClearService";
import useGlobalModel from "@/model/globalModel";
import { ISCMAssetsClearSearchFields, ISCMAssetsClearDetail, ISCMAssetsClearStatistics } from "./assetsClearTypes";
import { convertRes2Blob } from "@/utils/exportFile";
import { transPgToPagination } from "@/utils/utils";
import { isArray } from "util";
import { ISCMAssetsEntrySearchFields } from "../assetsEntry/assetsEntryTypes";
import { globalPrompt } from "@/components/message";
import { assetsEntryService } from "../assetsEntry/assetsEntryService";
import { message } from "antd";
import { debounce } from "lodash";
export const useAssetsClearModel = createModel(function () {
    const { user: { shopId, shopCode }, setLoadingInfo } = useGlobalModel();
    //查询条件
    const [searchParam, setSearchParam] = useState<ISCMAssetsClearSearchFields>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<ISCMAssetsClearDetail[]>([]);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //列表数据源分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //列表统计展示数据
    const initStatistics = {
        // aggregateAmount: "0.00",
        // paidAmount: "0.00",
        totalAmount: "0.00",
        totalNum: 0
    };
    const [statistics, setStatistics] = useState<ISCMAssetsClearStatistics>(initStatistics);
    const [loading, setLoading] = useState<boolean>(false);
    /**
     * 打印
     */
    const [print, setPrint] = useState<boolean>(false)
    const updateSearchParam = (updateParam: ISCMAssetsClearSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    const loadData = async (page?: ISearchPage, searchValue: ISCMAssetsClearSearchFields = searchParam) => {
        setLoading(true);
        const searchParams = {
            ...searchValue,
            type: "assets.clean",
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await assetsClearService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setLoading(false);
        loadTotal(searchParams);

    }
    const loadTotal = async (searchParams: any) => {
        let { retData: statistics } = await assetsClearService.pageStatistics(searchParams);
        setStatistics(statistics ?? initStatistics);
    }

    // 打印标签
    const GetprintTip = async (searchValue: ISCMAssetsEntrySearchFields = searchParam) => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt('message', { text: '请选择单条数据进行打印标签，点击鼠标右键可一键选中哦！', type: 'warning' })
            return
        }
        globalPrompt('modal', {
            title: '打印标签',
            type: 'warning',
            text: '您是否打印此商品标签？',
            okText: '确认',
            onOk: debounce(async () => {
                try {
                    let result = await assetsClearService.GetprintTip(selectedRowKeys[0]);
                    result && message.success('标签打印成功！')
                } catch{ message.error('标签打印失败！') }
            }, 500),
            cancelText: '取消',
            onCancel: () => {},
        })

        }
    //导出
    const exportData = async (searchValue: ISCMAssetsClearSearchFields = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            const searchParams = {
                ...searchValue,
                type: "assets.clean",
                pageSize: -1,
                pageNum:1,
                id:selectedRowKeys?.toString()
            }
            let result = await assetsClearService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch{ setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        statistics,
        loading,
        print, 
        /***method***/
        setPrint,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        exportData,
        GetprintTip

    }
});